// framer-motion verwijderd — entree-animatie via `animate-fade-in`.
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { homeFAQ } from "@/data/faqs";

/**
 * Compacte FAQ-sectie op de homepage. Vragen/antwoorden zijn 1-op-1 identiek
 * aan de `homeFAQ` subset (hergebruikt uit `/faq`) — Google vereist dat
 * `FAQPage` JSON-LD letterlijk op de pagina staat.
 */
const HomeFAQ = () => {
  return (
    <section className="border-t border-border/60 bg-muted/30 py-16 md:py-24">
      <div className="container max-w-3xl">
        <div className="mb-10 text-center animate-fade-in">
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl">
            Veelgestelde <span className="text-gradient">vragen</span>
          </h2>
          <p className="mt-3 text-base leading-relaxed text-muted-foreground md:text-lg">
            De vragen die ondernemers ons het vaakst stellen — kort en duidelijk
            beantwoord.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {homeFAQ.map((item, i) => (
            <AccordionItem key={i} value={`home-faq-${i}`}>
              <AccordionTrigger className="text-left text-base font-semibold md:text-lg">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-base leading-relaxed text-muted-foreground">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-10 text-center">
          <Button variant="hero-outline" asChild>
            <Link to="/faq">
              Bekijk alle veelgestelde vragen
              <ArrowRight className="ml-1 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HomeFAQ;
